import { useIntl } from 'react-intl';

import { ApiWorkflowDialogMessages } from '@verantos-dev/shared-components';

export const useProcessCohortDefinitionModalString = (cohortName?: string) => {
  const intl = useIntl();

  const apiWorkflowDialogMessages: ApiWorkflowDialogMessages = {
    entrySaveButtonText: intl.formatMessage({
      id: 'common.button.confirm',
    }),
    submittingSaveButtonText: intl.formatMessage({
      id: 'projects.cohortBuilderPage.processCohortDefinitionModal.processing',
    }),
    loadingSaveButtonText: intl.formatMessage({
      id: 'common.button.confirm',
    }),
    successText: intl.formatMessage(
      {
        id: 'projects.cohortBuilderPage.processCohortDefinitionModal.successText',
      },
      {
        cohortName: cohortName || 'Cohort',
      }
    ),
  };

  const dialogContentMessages = {
    title: intl.formatMessage({
      id: 'projects.cohortBuilderPage.processCohortDefinitionModal.confirmTitle',
    }),
    message1: intl.formatMessage({
      id: 'projects.cohortBuilderPage.processCohortDefinitionModal.message1',
    }),
    processing: intl.formatMessage({
      id: 'projects.cohortBuilderPage.processCohortDefinitionModal.processing',
    }),
    processed: intl.formatMessage({
      id: 'projects.cohortBuilderPage.processCohortDefinitionModal.ready',
    }),
  };

  return { apiWorkflowDialogMessages, dialogContentMessages };
};
